import { format, Locale, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date: Date | string | number) {
  return format(new Date(date), 'yyyy-MM-dd');
}

export function fDateTime(date: Date | string | number) {
  return format(new Date(date), 'yyyy-MM-dd HH:mm');
}

export function fLocalDateTime(date: Date | string | number) {
  const dateValue = new Date(date);

  const localDate = dateValue.toLocaleDateString('lt-LT');
  const localTime = dateValue.toLocaleTimeString('lt-LT');

  return `${localDate} ${localTime}`;
}

export function fTimestamp(date: Date | string | number) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date: Date | string | number) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date: Date | string | number, locale?: Locale) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
    locale,
  });
}
